<tui-accordion class="text-left" [closeOthers]="false">
  @for (item of items(); track item.question) {
    <button tuiAccordion class="!h-auto !px-5 !py-4">
      <span class="text-wrap font-bold">{{ item.question }}</span>
    </button>
    <tui-expand>
      <p [innerHTML]="item.answer"></p>
    </tui-expand>
  }
</tui-accordion>
